module.exports = __webpack_public_path__ + "img/thumbnail_NorthAmericanBeaver_j_normal.d394ae55.png";